var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowhalfcircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.851,
    height: 267.246,
    viewBox: "0 0 193.851 267.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7675",
    "data-name": "Group 7675",
    transform: "translate(-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M0,0H0V267.246A138.261,138.261,0,0,0,25.046,262.4a137.172,137.172,0,0,0,23.176-9.124,137.208,137.208,0,0,0,20.854-12.958,136.848,136.848,0,0,0,18.078-16.346A135.369,135.369,0,0,0,102,204.686,133.381,133.381,0,0,0,113.171,182.9a132.076,132.076,0,0,0,7.033-23.837,133.362,133.362,0,0,0,2.445-25.441,133.368,133.368,0,0,0-2.445-25.441,132.058,132.058,0,0,0-7.033-23.836A133.365,133.365,0,0,0,102,62.559,135.41,135.41,0,0,0,87.154,43.27,136.916,136.916,0,0,0,69.076,26.924,137.21,137.21,0,0,0,48.223,13.967,137.232,137.232,0,0,0,25.046,4.843,138.294,138.294,0,0,0,0,0Z",
    transform: "translate(82.203)",
    fill: "#fdb913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M99.628,108.544H0V0A111.177,111.177,0,0,1,70.8,35.149,109.974,109.974,0,0,1,82.858,50.818a108.337,108.337,0,0,1,9.071,17.7,107.081,107.081,0,0,1,7.7,40.029Z",
    transform: "translate(110.628 146.006) rotate(180)",
    fill: "#e3334a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowhalfcircle);
export default __webpack_public_path__ + "static/media/yellowhalfcircle.ce38f14aaece0fce43a42a7079a4e913.svg";
export { ForwardRef as ReactComponent };